import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { RouterModule } from '@angular/router';
import { InMemoryCache, split } from '@apollo/client/core';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { Apollo, ApolloModule } from 'apollo-angular';
import { createClient } from 'graphql-ws';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule, ApolloModule],
  declarations: [],
  exports: [],
  providers: [AuthService],
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
    apollo: Apollo
  ) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }

    const http = new BatchHttpLink({ uri: environment.graphql.uri });

    const errorLink = onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) =>
          console.log(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
          )
        );
      }
      if (networkError) {
        console.log(`[Network error]: ${networkError}`);
      }
    });

    const httpWithMiddleware = errorLink.concat(http);

    const ws = new GraphQLWsLink(
      createClient({
        url: environment.graphql.wsUri,
        connectionParams: () => ({
          authentication: localStorage.getItem('access_token'),
        }),
      })
    );

    const link = split(
      // split based on operation type
      ({ query }) => {
        const definition = getMainDefinition(query);
        return (
          definition.kind === 'OperationDefinition' &&
          definition.operation === 'subscription'
        );
      },
      ws,
      httpWithMiddleware
    );

    apollo.create({
      link,
      name: 'Budget Calculator',
      version: environment.version,
      cache: new InMemoryCache(),
      defaultOptions: {
        watchQuery: {
          errorPolicy: 'all',
        },
      },
    });
  }
}
